import React, { useRef } from 'react'

import DoneIcon from '../../assets/svg/done.inline.svg'
import * as styles from './form.module.scss'

const ContactForm = ({
    formId,
    layout,
    loading,
    message,
    formName,
    email,
    name,
    text,
    handleSubmit,
    submitted,
    isSubmitSuccess,
    setBot,
    setEmail,
    setName,
    setText,
}) => {
    const emailInputEl = useRef(null)
    const nameInputEl = useRef(null)
    const textInputEl = useRef(null)

    return (
        <form id={formId ? formId : 'contact'} onSubmit={e => handleSubmit(e, 'contact')}>
            <input type='hidden' name='bot' onChange={e => setBot(e.target.value)} />
            <input type='hidden' name='form-name' value={formName ? formName : 'contact'} />
            <div className={styles.formRowColumn}>
                {isSubmitSuccess ? (
                    <div className={styles.success}>
                        <DoneIcon />
                        <h5>Спасибо!</h5>
                        <p className={styles.formMessage} dangerouslySetInnerHTML={{ __html: message }} />
                    </div>
                ) : (
                    <>
                        <div className={styles.formItem}>
                            <label className={styles.formSubItem}>
                                <input
                                    ref={nameInputEl}
                                    type='text'
                                    name='name'
                                    id={formName + 'name'}
                                    className={styles.formField}
                                    onChange={e => setName(e.target.value)}
                                    value={name}
                                    disabled={loading}
                                    placeholder='Ваше Имя'
                                    required
                                />
                            </label>
                            <label className={styles.formSubItem}>
                                <input
                                    ref={emailInputEl}
                                    type='email'
                                    name='email'
                                    id={formName + 'email'}
                                    className={styles.formField}
                                    onChange={e => setEmail(e.target.value)}
                                    value={email}
                                    disabled={loading}
                                    placeholder='Ваш Email'
                                    required
                                />
                            </label>
                        </div>
                        <div className={styles.formItem}>
                            <label>
                                <textarea
                                    ref={textInputEl}
                                    name='text'
                                    id={formName + 'text'}
                                    className={styles.formField}
                                    onChange={e => setText(e.target.value)}
                                    value={text}
                                    disabled={loading}
                                    placeholder='Ваше сообщение'
                                />
                            </label>
                        </div>
                        <button type='submit' className={styles.formButton + ' contact-form'} disabled={loading}>
                            <span style={{ display: 'inline-block', marginTop: 2 + 'px' }}>Оставить заявку</span>
                            {loading && <span className={styles.formLoader} />}
                        </button>
                        {submitted && (
                            <p className={styles.formMessage} dangerouslySetInnerHTML={{ __html: message }} />
                        )}
                    </>
                )}
            </div>
        </form>
    )
}

export default ContactForm
